import React from 'react';

import PropTypes from 'prop-types';

import { ReactRenderingContent as ReactRenderingContentEnum } from 'constants/formBuilder';

import { DynamicFieldItemView } from '../dynamicField';
import Signature from '../signature';

const ReactRenderingContent = ({ dataTemplateFieldType, isNewItem = false, ...restProps }) => {
  switch (dataTemplateFieldType) {
    case ReactRenderingContentEnum.DYNAMIC_FIELD:
      return <DynamicFieldItemView {...restProps} isNewItem={isNewItem} />;

    case ReactRenderingContentEnum.SIGNATURE: {
      return <Signature {...restProps} isNewItem={isNewItem} />;
    }

    default:
      return null;
  }
};

ReactRenderingContent.propTypes = {
  dataTemplateFieldType: PropTypes.string.isRequired,
  isNewItem: PropTypes.bool,
};

export default ReactRenderingContent;
